module.exports = __webpack_public_path__ + "img/AK0091-LI.b9ac4393.jpg";